module.exports = __webpack_public_path__ + "img/ep4-5.0dec255c.png";